export enum ReminderTypes {
  WorkerReminder = 'Worker reminder',
  ClientReminder = 'Client reminder',
  ActionPlanItemDue = 'Action plan item (due)',
  ActionPlan = 'Action plan',
  Referral = 'Referral',
}

export const ReferralReminderTitle = 'Follow up on Service Provider referral';
